const filters = {
  formatNumber(number: any) {
    try {
      const si = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" },
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      let i;
      for (i = si.length - 1; i > 0; i--) {
        if (number >= si[i].value) {
          break;
        }
      }
      return (number / si[i].value).toFixed(2).replace(rx, "$1") + si[i].symbol;
    } catch (error) {
      return "-";
    }
  },
  highlight(words: any, query: any) {
    const iQuery = new RegExp(query, "ig");
    return words
      .toString()
      .replace(iQuery, function (matchedTxt: any, a: any, b: any) {
        return "<span class='highlight'>" + matchedTxt + "</span>";
      });
  },
};

export default filters;
